/**
 * Created by nguyendx 2017/12/01.
 */
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Rx';

@Injectable()
export class CommonService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }

  file(path) {
    if (path && path.indexOf('http') == -1) {
      return environment.api_evs + '/' + path;
    } else {
      return path;
    }
  }

  imageFb(id) {
    return 'https://graph.facebook.com/' + id + '/picture?type=square';
  }

  next(url: string, options?: any) {
    // console.log(url);
    return this.getFullUrl(url, options);
  }

  import(body) {
    return this.post('/import', body);
  }

  findImport(query?: any) {
    return this.get('/find-import', query);
  }

  updateImport(job_id, body) {
    return this.put('/update-import/' + job_id, body);
  }

  settingCommon(query?: any) {
    return this.get('/v2/setting-common', query);
  }
  settingUserConfig(body) {
    return this.post('/v2/setting-user-config', body);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Common.service.ts